import React from 'react';
import { Wrapper, Header, Title, Logo, Text } from './SplashScreen.styles';
import logo from '../../assets/images/logo.svg';

const SplashScreen = () => (
  <Wrapper>
    <Header>
      <Title>
        <span>Digitale</span>
        <br />
        Gästemappe
      </Title>
      <Logo src={logo} alt='Hausboot Niederrhein' />
    </Header>
    <Text>Anwendung wird gestartet</Text>
  </Wrapper>
);

export default SplashScreen;
